(function () {
  var INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, video, [role="button"]';

  function getSlide(target) {
    if (!target || !target.closest) return null;
    return target.closest('.cstm-slide-clickable');
  }

  document.addEventListener('click', function (e) {
    var slide = getSlide(e.target);
    if (!slide) return;
    if (e.target.closest(INTERACTIVE_SELECTOR)) return;
    var url = slide.dataset.cstmSlideLink;
    if (!url) return;
    window.location.href = url;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var slide = getSlide(e.target);
    if (!slide || slide !== e.target) return;
    e.preventDefault();
    var url = slide.dataset.cstmSlideLink;
    if (url) window.location.href = url;
  });
})();
